export default "<p>stocking-dash-board works!</p>\n";